import { Injectable } from '@angular/core';
import { Team, Studio, Job, DocumentSegment, Offer } from '@app/shared';


export const layouts = {
  GRID_LAYOUT: 'grid-layout',
  FLAT_LAYOUT:'flat-layout',
  SPREADSHEET_LAYOUT:'spreadsheet-layout',
  REPORT_LAYOUT:'report-layout',
};
export const teamAssignTypes = {
  JOB: 'JOB',
  SINGLE_DOC_SEGMENT: 'SINGLE_DOC_SEGMENT',
  MULTI_DOC_SEGMENT: 'MULTI_DOC_SEGMENT',
  PROJECT: 'PROJECT',
}
export const studioAssignTypes = {
  JOB: 'JOB',
  SINGLE_DOC_SEGMENT: 'SINGLE_DOC_SEGMENT',
  MULTI_DOC_SEGMENT: 'MULTI_DOC_SEGMENT',
  PROJECT: 'PROJECT',
}

@Injectable()
export class JobUtils {

  userIsAdmin(user):boolean{
    const adminRoles = ["PM_Administrator","PM_Superuser"];
    //return user.roles.find(val => val === adminRoles);
    return this.arraysHaveMatch(user.roles,adminRoles).length?true:false;
  }

  getDocumentSegmentByIndex(job:Job,idx:number):DocumentSegment{
    let result;
    for(let ds of job.documentSegments ){
      if(parseInt(ds.segmentNumber) === idx)
        result = ds;
    }
    return result;
  }

  getTeamFromName(val:string,teams:Team[]):Team{

    var result:Team;
    if(teams){
      for(let team of teams){
        if(team.name === val || team.descr === val){
          result = team;
          break;
        }
      }
      // teams.map(team =>{
      //
      //   if(team.name === val || team.descr === val)
      //     result = team;
      // });
    }
    return result;
  }

  getOfferRender(offer:Offer,type:string):string{
    let res = "";
    if(offer){
      if(type === 'thumb'){
        if(offer.offerTypeDescr && offer.offerTypeDescr.toLowerCase() === 'vendor' || (offer.offerType && offer.offerType.name.toLowerCase() === 'vendor')){
          res = offer.heroAssetMediaURL?offer.heroAssetMediaURL:'';
        }else{
          res = offer.offerViewThumb?offer.offerViewThumb:'';
        }
      }else{
        if(offer.offerTypeDescr && offer.offerTypeDescr.toLowerCase() === 'vendor' || (offer.offerType && offer.offerType.name.toLowerCase() === 'vendor')){
          res = offer.heroAssetMediaPreviewURL?offer.heroAssetMediaPreviewURL:'';
        }else{
          res = offer.offerViewPreview?offer.offerViewPreview:'';
        }
      }
    }

    return res;
  }

  getStudioFromCode(val:string,studios:Studio[]):Studio{
    var result:Studio;
    if(studios){
      for(let studio of studios){
        if(studio.code === val){
          result = studio;
          break;
        }
      }
    }
    return result;
  }


  isLocked(val:any):boolean{
    let valid = false;
    if(val && val.lockStatus && val.lockStatus === "T")
      valid = true;

    return valid;
  }

  // return an array of matched values
  arraysHaveMatch(firstArray:string[],secondArray:string[]):any[]{
    let jsonArray = [];
    firstArray.map(i => {
       //return { 'name': i, 'matched': secondArray.includes(i) };
       if(secondArray.includes(i))
        jsonArray.push(i);
    });


    return jsonArray;
  }

  strToObj(str){
     var obj = {};
     if(str||typeof str ==='string'){
         var objStr = str.match(/\{(.)+\}/g);
         eval("obj ="+objStr);
     }
     return obj
  }

  

  // canFaveOffer(offer:Offer,user:User):boolean{
  //   return this.arraysHaveMatch(user.departments,[offer.department]).length?true:false;
  // }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/utils/job-utils.ts